import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { createRuns } from "../../api/services/scheduling";
import queryClient from "../../base/QueryClient";
import { QK } from "../../base/qk";

const TemplateRunModal = ({ open, onClose, templateId }) => {
  const [runName, setRunName] = useState("");
  const [runType, setRunType] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!runName || !runType) {
      enqueueSnackbar("Please fill all the fields", { variant: "error" });
      return;
    }

    try {
      const response = await createRuns({
        name: runName,
        template: templateId,
        run_type: runType,
      });

      if (response.status === 201) {
        queryClient.invalidateQueries([QK.runs]);
        enqueueSnackbar("Run created successfully", { variant: "success" });
      }
    } catch (err) {
      enqueueSnackbar("Failed to create run", { variant: "error" });
    } finally {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px" } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pr: 1,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Create New Run
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="close">
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <Box component="form" onSubmit={handleSubmit}>
        <DialogContent dividers sx={{ p: 3 }}>
          <TextField
            fullWidth
            label="Run Name"
            placeholder="Enter the run name"
            value={runName}
            onChange={(e) => setRunName(e.target.value)}
            size="small"
            sx={{ mb: 3 }}
          />

          <TextField
            select
            fullWidth
            label="Run Type"
            value={runType}
            onChange={(e) => setRunType(e.target.value)}
            size="small"
          >
            <MenuItem value="">Select Run Type</MenuItem>
            <MenuItem value="am">AM</MenuItem>
            <MenuItem value="pm">PM</MenuItem>
          </TextField>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button variant="contained" color="primary" type="submit">
            Submit
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default TemplateRunModal;